import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useSlice } from "components/hooks/useSlice";
import { ExternalLink } from "components/ui/ExternalLink";
import VisuallyHidden from "components/ui/VisuallyHidden";
export function PopoverHeader({ service }) {
  const { hasGoogleAccessToken, officialBmailAddress } = useSlice("myStatus");
  const serviceHeaders = {
    Mail: "Unread bMail Messages",
    Cal: "Unaccepted bCal Invitations",
    Drive: "bDrive Updates",
  };

  return (
    <PopoverHeaderStyles>
      <h4>
        {hasGoogleAccessToken
          ? serviceHeaders[service]
          : `b${service} (${
              officialBmailAddress ? "Not connected" : "Account Not Ready"
            })`}
      </h4>

      <ExternalLink href={`http://b${service}.berkeley.edu`}>
        <VisuallyHidden>Go to b{service}</VisuallyHidden>
      </ExternalLink>
    </PopoverHeaderStyles>
  );
}

PopoverHeader.propTypes = {
  service: PropTypes.oneOf(["Mail", "Cal", "Drive"]),
};

const PopoverHeaderStyles = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--sm) var(--md);

  h4 {
    margin: 0;
    font-size: 14px;
  }
`;
